import "./boxmenudrop.css";
import React, { useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh } from "@fortawesome/free-solid-svg-icons";
import useOutsideClick from "../../shared/hooks/useOutsideClick";
import logo from "../../images/s-logo.png";
import li from "../../images/linkedIn-icon.png";
import gh from "../../images/github-icon.png";
import email from "../../images/gmail-icon.png";
import about from "../../images/info.png";
import suitcase from "../../images/suitcase.png";
import newspaper from "../../images/newspaper.png";

const BoxMenuDrop = () => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const close = useCallback(() => setIsOpen(false), []);
  useOutsideClick(wrapperRef, close);

  return (
    <div className="dropdown" onClick={() => setIsOpen((prev) => !prev)} ref={wrapperRef}>
      <FontAwesomeIcon className="fas fa-th dropbtn" icon={faTh} />
      <div
        id="drop"
        className={
          isOpen
            ? "dropdown-content-cont dropdown-show"
            : "dropdown-content-cont dropdown-hide"
        }
      >
        <div className="drop-item">
          <Link className="drop-link" to="/">
            <img src={logo} alt="" />
            <p> Search </p>
          </Link>
          <Link className="drop-link" to="/about">
            <img src={about} alt="" />
            <p> About </p>
          </Link>
          <Link className="drop-link" to="/email">
            <img src={email} alt="" />
            <p> Email </p>
          </Link>
          <Link className="drop-link" to="/projects">
            <img src={suitcase} alt="" />
            <p> Projects </p>
          </Link>
          <Link className="drop-link" to="/maps">
            <img src={newspaper} alt="" />
            <p> Maps </p>
          </Link>
          <Link className="drop-link" to="/drive">
            <img src={about} alt="" />
            <p> Drive </p>
          </Link>
          <a className="drop-link" href="https://github.com/jasur-2902">
            <img src={gh} alt="" />
            <p> GitHub </p>
          </a>
          <a
            className="drop-link"
            href="https://www.linkedin.com/in/jasurshukurov/"
          >
            <img src={li} alt="" />
            <p> LinkedIn </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BoxMenuDrop;
